/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".lang-switcher-backoffice[_ngcontent-%COMP%]{display:none!important}"];
export { styles as styles };
